import  * as Constants from '../constants/XookConstants';

export const storeXookData = (payload:any) => {
    return {
        type:Constants.STORE_XOOK_DATA,
        data:payload
    }
}

export const clearXookData = (payload:any) => {
    return {
        type:Constants.CLEAR_XOOK_DATA,
        data:payload
    }
}

export const setXookServingData = (payload:any) => {
    return{
        type:Constants.SET_XOOK_SERVING_DATA,
        data:payload
    }
}

export const setCurrency = (payload:any) => {
    return {
        type:Constants.SET_CURRENCY,
        data:payload
    }
}

export const setDataPollingId = (payload:any) => {
    return {
        type:Constants.SET_DATA_POLLING_ID,
        data:payload
    }
}
